var React = require('react');

function ChevronLargeRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M7.837 9.262a.91.91 0 0 0-1.277 0 .877.877 0 0 0 0 1.245l5.463 5.375a.75.75 0 0 0 1.052 0l5.463-5.375a.877.877 0 0 0 0-1.245.91.91 0 0 0-1.278 0l-4.711 4.635-4.712-4.635z","id":"a"})),React.createElement("g",{"fill":"currentColor","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("use",{"fill":"#000","fillRule":"nonzero","transform":"rotate(-90 12.549 12.549)","xlinkHref":"#a","key":1})])]);
}

ChevronLargeRight.defaultProps = {"width":"25","height":"25"};

module.exports = ChevronLargeRight;

ChevronLargeRight.default = ChevronLargeRight;
